import * as React from 'react';

import { createIcon } from '../Icon';
export const SkipForwardIcon = createIcon(
  <React.Fragment>
    <polygon points="5 4 15 12 5 20 5 4" />
    <line x1={19} x2={19} y1={5} y2={19} />
  </React.Fragment>,
  'SkipForwardIcon'
);
